var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmartPauseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "vuesax/outline/calendar-circle"
  }, /*#__PURE__*/React.createElement("g", {
    id: "calendar-circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 18.9587C5.05833 18.9587 1.04167 14.942 1.04167 10.0003C1.04167 5.05866 5.05833 1.04199 10 1.04199C14.9417 1.04199 18.9583 5.05866 18.9583 10.0003C18.9583 14.942 14.9417 18.9587 10 18.9587ZM10 2.29199C5.75 2.29199 2.29167 5.75033 2.29167 10.0003C2.29167 14.2503 5.75 17.7087 10 17.7087C14.25 17.7087 17.7083 14.2503 17.7083 10.0003C17.7083 5.75033 14.25 2.29199 10 2.29199Z",
    fill: "#1F435D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.24178 7.15006C7.90011 7.15006 7.61678 6.86673 7.61678 6.52506V4.8584C7.61678 4.51673 7.90011 4.2334 8.24178 4.2334C8.58345 4.2334 8.86678 4.51673 8.86678 4.8584V6.52506C8.86678 6.86673 8.59178 7.15006 8.24178 7.15006Z",
    fill: "#1F435D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M11.7582 7.15006C11.4166 7.15006 11.1332 6.86673 11.1332 6.52506V4.8584C11.1332 4.51673 11.4166 4.2334 11.7582 4.2334C12.0999 4.2334 12.3832 4.51673 12.3832 4.8584V6.52506C12.3832 6.86673 12.0999 7.15006 11.7582 7.15006Z",
    fill: "#1F435D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M13.725 9.0752H6.26668C5.92502 9.0752 5.64168 8.79186 5.64168 8.4502C5.64168 8.10853 5.92502 7.8252 6.26668 7.8252H13.725C14.0667 7.8252 14.35 8.10853 14.35 8.4502C14.35 8.79186 14.075 9.0752 13.725 9.0752Z",
    fill: "#1F435D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M11.25 15.3503H8.75C6.45833 15.3503 4.79167 13.6836 4.79167 11.3919V8.89193C4.79167 6.60026 6.45833 4.93359 8.75 4.93359H11.25C13.5417 4.93359 15.2083 6.60026 15.2083 8.89193V11.3919C15.2083 13.6836 13.5417 15.3503 11.25 15.3503ZM8.75 6.18359C6.875 6.18359 6.04167 7.54193 6.04167 8.89193V11.3919C6.04167 12.7419 6.875 14.1003 8.75 14.1003H11.25C13.125 14.1003 13.9583 12.7419 13.9583 11.3919V8.89193C13.9583 7.54193 13.125 6.18359 11.25 6.18359H8.75Z",
    fill: "#1F435D"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartPauseIcon);
export default __webpack_public_path__ + "static/media/smart-pause-icon.6b7d36f25683cf6fd4849818e8d82de7.svg";
export { ForwardRef as ReactComponent };